import {
  Bar,
  BarChart,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import { format, parseISO } from "date-fns";
import { useFormSubmissionStats } from "../hooks/use-form-submission-stats";

export default function FormSubmissionsChart({ formId }: { formId: string }) {
  const { data, isLoading } = useFormSubmissionStats(formId, 7);

  if (isLoading) {
    return <div className="h-40 animate-pulse bg-gray-100 rounded" />;
  }

  const chartData = (data ?? []).map((d) => ({
    day: format(parseISO(`${d.date}T00:00:00Z`), "EEE"),
    count: d.count,
  }));
  const total = chartData.reduce((s, d) => s + d.count, 0);

  return (
    <div>
      <p className="text-xs font-medium text-gray-500 mb-2">
        Submissions · last 7 days ({total})
      </p>
      <ResponsiveContainer width="100%" height={160}>
        <BarChart data={chartData} margin={{ top: 4, right: 8, bottom: 0, left: 0 }}>
          <CartesianGrid strokeDasharray="3 3" vertical={false} />
          <XAxis
            dataKey="day"
            tick={{ fontSize: 11 }}
            axisLine={false}
            tickLine={false}
          />
          <YAxis
            allowDecimals={false}
            width={28}
            tick={{ fontSize: 11 }}
            axisLine={false}
            tickLine={false}
          />
          <Tooltip cursor={{ fill: "rgba(0,0,0,0.04)" }} />
          <Bar dataKey="count" fill="#3b82f6" radius={[4, 4, 0, 0]} />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}
